/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import FormInput from '../components/FormInput';
import { withParamsAndNavigate } from '../components/WithParamsAndNavigate';
import '../css/style.css';
import { qreq } from '../shared/qrequest';
import BaseCom from '../components/BaseCom';
import Alert from '../components/Alert';

class Login extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            credentials: {},
            submitting: false
        };
        this.submit = this.submit.bind(this);
        this.submitMFA = this.submitMFA.bind(this);
        this.setUser = this.setUser.bind(this);
    }


    async componentDidMount() {
        await this.getMainOrg((j) => {
            this.setState({ instanceError: j.errorMessage })
        });
        await this.getSettings();
    }

    setUser() {
        this.props.setUser?.();
    }

    submit(e) {
        e.preventDefault();
        this.setState({ submitting: true });
        qreq.post('/api/auth/login', this.state.credentials, j => {
            if (j.errorCode === 101)
                this.setState({ mfa: true, medium: j.errorMessage });
            else if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.item) {
                this.setState({ loginSuccess: true });
                this.continue();
            }
            this.setState({ submitting: false });
        }, e => {
            this.alert('An unkown error ocurred. Login service might be down.');
            this.setState({ submitting: false });
        });
    }

    submitMFA(e) {
        e.preventDefault();
        this.setState({ submitting: true });
        qreq.post('/api/auth/mfa', { ...this.state.credentials }, j => {
            if (j.errorCode) {
                this.alert(j.errorMessage);
                this.setState({ submitting: false });
            }
            else {
                this.setState({ loginSuccess: true });
                this.continue();
            }
        }, e => {
            this.alert('An unkown error ocurred. Login service might be down.');
            this.setState({ submitting: false });
        });
    }

    continue = () => {
        if (this.props.params.follow)
            window.location.replace(atob(this.props.params.follow));
        else
            window.location.replace('/dashboard');
    }

    render() {
        return (
            <div className="c-login">
                <div className="container-fluid c-login-container" style={{ backgroundImage: 'url(\'/img/login-right-bg.jpg\')' }}>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6 bg-white c-login-left">
                            <div className="c-login-content">
                                {this.state.loginSuccess ? <div className="row justify-content-center">
                                    <div className="col-md-5">
                                        <img src={this.getMainOrgLogoURL()} alt="" className="img-fluid mx-auto w-50 d-block d-md-none mb-5" />
                                        <h2 className="text-center">Login Successful</h2>
                                        <hr />
                                        <p className="text-center">Loading the portal...please wait...</p>
                                    </div>
                                </div> : this.state.mfa ? <div className="row justify-content-center">
                                    <div className="col-md-5">
                                        <img src={this.getMainOrgLogoURL()} alt="" className="img-fluid mx-auto w-50 d-block d-md-none mb-5" />
                                        <h2 className="text-center">Multi-Factor Authentication</h2>
                                        <hr />
                                        <p className="text-center">A code has been sent to your {this.state.medium}. Please enter it below.</p>
                                        <form onSubmit={this.submitMFA}>
                                            <FormInput model={this.state.credentials} name="code" label="Code" type="text" required={true} />
                                            <div className="d-grid mt-4">
                                                <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}>Submit</button>
                                            </div>
                                            <div className="text-center mt-2">
                                                <span role="button" onClick={() => this.setState({ mfa: false, medium: null, credentials: { username: this.state.credentials.username } })}>Cancel and Go Back</span>
                                            </div>
                                        </form>
                                    </div>
                                </div> : <div className="row justify-content-center">
                                    <div className="col-md-5">

                                        {this.state.instanceError ? <>
                                            <Alert type="danger">{this.state.instanceError}</Alert>
                                        </>
                                            : <>
                                                <img src={this.getMainOrgLogoURL()} alt="" className="img-fluid mx-auto w-50 d-block d-md-none mb-5" />
                                                <form onSubmit={this.submit}>
                                                    <h2 className="text-center">Login</h2>
                                                    <small className="d-block text-muted text-center">To the <b>u</b>nivseral <b>d</b>ata <b>h</b>ealth <b>s</b>ystem.</small>
                                                    <hr />
                                                    <FormInput model={this.state.credentials} name="username" label="Email Address" type="text" required={true} labelAsPlaceholder={true} autoComplete="username" />
                                                    <FormInput model={this.state.credentials} name="password" label="Password" type="password" required={true} labelAsPlaceholder={true} autoComplete="current-password" />
                                                    <FormInput model={this.state.credentials} name="isPersistent" label="Remember Me?" type="switch" />
                                                    <div className="d-grid mt-4">
                                                        <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}>Login</button>
                                                    </div>
                                                </form>
                                                {this.state.error ? (<div className="alert alert-danger mt-2">{this.state.error}</div>) : ''}
                                            </>}
                                    </div>
                                </div>}

                            </div>
                        </div>
                        <div className="col-md-6 d-none d-md-block">
                            <div className="c-login-right">
                                <div className="img-wrapper">
                                    <img src={this.getMainOrgLogoURL(true)} alt="" className="img-fluid w-50 d-block mx-auto" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default withParamsAndNavigate(Login);